import { useI18n } from "providers/I18nProvider";
import { useGlobalSearchContext } from "../context";
import { CompanySearchItem } from "./CompanySearchItem";
import { SectionHeader } from "./SectionHeader";

export const Companies = () => {
  const { t } = useI18n();
  const { companies } = useGlobalSearchContext();

  if (companies.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col">
      <SectionHeader title={t("apps.admin.common.companies")} />

      {companies.map((company) => (
        <CompanySearchItem key={company.id} company={company} />
      ))}
    </div>
  );
};
